export default __webpack_public_path__ + "static/media/vecf-wide-logo.41fdc77f.jpg";